// Константы для ролей — единый источник в utils/constants.js
import { USER_ROLES } from './constants';
export { USER_ROLES } from './constants';


// Сохраняем пользователя
export const setUser = (user) => {
    // Добавляем timestamp для контроля сессии
    const userWithTimestamp = {
        ...user,
        _lastUpdated: Date.now()
    };
    localStorage.setItem('user', JSON.stringify(userWithTimestamp));
};

// Получаем пользователя
export const getUser = () => {
    try {
        const userData = localStorage.getItem('user');
        if (!userData) return null;

        const user = JSON.parse(userData);

        // Опционально: проверяем срок жизни сессии (например, 24 часа)
        const SESSION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 часа
        if (user._lastUpdated && (Date.now() - user._lastUpdated > SESSION_TIMEOUT)) {
            removeUser();
            return null;
        }

        return user;
    } catch (error) {
        console.error('Error parsing user data:', error);
        removeUser();
        return null;
    }
};

// Удаляем пользователя
export const removeUser = () => {
    localStorage.removeItem('user');
};